import { FormattedMessage } from 'react-intl';
import Tooltip from 'components/Tooltip';

import {
  StyledExternalUserLabel,
  StyledExternalUserPendingLabel,
} from './ExternalUserLabels.styled';

export function ExternalUserLabel() {
  return (
    <StyledExternalUserLabel
      label={
        <FormattedMessage
          id="externalUser.title"
          defaultMessage="External User"
        />
      }
    />
  );
}

export function ExternalUserPendingLabel() {
  return (
    <StyledExternalUserPendingLabel
      label={
        <FormattedMessage
          id="externalUser.pending"
          defaultMessage="Awaiting Registration"
        />
      }
    />
  );
}

export function ExternalUserRegistrationLocationLabel({
  registrationLocation,
  userFullName,
}: {
  registrationLocation: string;
  userFullName: string;
}) {
  return (
    <Tooltip
      placement="right"
      title={
        <FormattedMessage
          id="pages.scorecards.externalUserRegistrationLocationTooltip"
          defaultMessage="{userFullName} completed registration in {registrationLocation}"
          values={{
            userFullName,
            registrationLocation,
          }}
        />
      }
    >
      <StyledExternalUserPendingLabel label={registrationLocation} />
    </Tooltip>
  );
}

export function ExternalUserDraftLabel() {
  return (
    <StyledExternalUserPendingLabel
      label={
        <FormattedMessage
          id="externalUser.notInvited"
          defaultMessage="Not invited yet"
        />
      }
    />
  );
}

export default ExternalUserLabel;
